var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    width: 140.679,
    height: 200.679,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h140.679v200.679H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#b1b1b1",
    strokeLinecap: "square",
    strokeMiterlimit: 3
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M17.679 156.161v21.188M56.547 156.161v21.188M45.442 156.161v21.188M100.968 156.161v21.188M23.231 156.161v21.188M73.205 156.161v21.188M50.994 156.161v21.188M106.521 156.161v21.188M28.784 156.161v21.188M78.758 156.161v21.188M62.1 156.161v21.188M112.073 156.161v21.188M34.336 156.161v21.188M84.31 156.161v21.188M67.652 156.161v21.188M117.626 156.161v21.188M39.889 156.161v21.188M95.415 156.161v21.188M89.863 156.161v21.188M123.179 156.161v21.188"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#b1b1b1",
    strokeLinecap: "square",
    strokeMiterlimit: 3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    vectorEffect: "non-scaling-stroke",
    d: "M13.804 57.411h113.25v84.179H13.804z"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M14.179 73.161h112.25M98.929 58.161v83.5"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    stroke: "#b1b1b1",
    strokeLinecap: "square",
    strokeMiterlimit: 3,
    d: "M13.929 133.161h112.886"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E7E7E7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.179 40.286h51.922v3.542H14.179zM14.179 32.293h41.562v3.542H14.179zM14.179 24.301h70.344v3.542H14.179z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    stroke: "#b1b1b1",
    strokeLinecap: "square",
    strokeMiterlimit: 3,
    d: "M1.5 1.5h137.679v197.679H1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillet);
export default __webpack_public_path__ + "static/media/billet.2f10460a059b2b827bebe148e6a53879.svg";
export { ForwardRef as ReactComponent };